import { createSelector } from 'reselect';
 
const selectMembershipTypes = (state: any) => state.membershipTypes;
 
export const selectMembershipTypesCurrentItem = createSelector([selectMembershipTypes], (membershipTypes) => membershipTypes.current);
 
export const selectMembershipTypesListItems = createSelector([selectMembershipTypes], (membershipTypes) => membershipTypes.list);
 
export const selectMembershipTypesQueryItems = createSelector([selectMembershipTypes], (membershipTypes) => membershipTypes.query);

export const selectMembershipTypesItemById = (itemId: any) =>
    createSelector(selectMembershipTypesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectMembershipTypesCreatedItem = createSelector([selectMembershipTypes], (membershipTypes) => membershipTypes.create);
 
export const selectMembershipTypesUpdatedItem = createSelector([selectMembershipTypes], (membershipTypes) => membershipTypes.update);
 
export const selectMembershipTypesReadItem = createSelector([selectMembershipTypes], (membershipTypes) => membershipTypes.read);
 
export const selectMembershipTypesDeletedItem = createSelector([selectMembershipTypes], (membershipTypes) => membershipTypes.delete);
 
export const selectMembershipTypesSearchedItems = createSelector([selectMembershipTypes], (membershipTypes) => membershipTypes.search);
 
export const selectMembershipTypesItemsCount = createSelector([selectMembershipTypes], (membershipTypes) => membershipTypes.count);
 
export const selectMembershipTypesItemsFilter = createSelector([selectMembershipTypes], (membershipTypes) => membershipTypes.filter);